/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonExternalSharedModule } from '@gh/common-external-shared';
import { UserContext } from '@gh/common-shared';
import { SupplierUserContext, SupplierUserContextService, SupplierUserProfileStore } from './user';

@NgModule({
  imports: [
    CommonExternalSharedModule.forChild(),
  ],
  declarations: [],
  exports: [
    CommonExternalSharedModule,
  ],
})
export class SupplierSharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SupplierSharedModule,
      providers: [
        { provide: SupplierUserContext, useClass: SupplierUserContextService },
        { provide: UserContext, useExisting: SupplierUserContext },
        SupplierUserProfileStore,
      ],
    };
  }

  static forChild(): ModuleWithProviders {
    return {
      ngModule: SupplierSharedModule,
      providers: [],
    };
  }
}
